// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BRCg0","newExpiryDate":"styles_newExpiryDate__17vHZ","footer":"styles_footer__38CBR"};